namespace $.$$ {
	
	$mol_test_mocks.push( $ => {
		$.$mol_wait_timeout = function $mol_wait_timeout_mock( this: $, timeout: number ) { }
		$.$mol_wait_timeout_async = async function $mol_wait_timeout_async_mock( this: $, timeout: number ) {}
	} )

}
